'use client';

import { useState } from 'react';

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Chip, Icon } from '@/components';

export function TableFilterDropdown({
  column,
  title,
  options,
  marginRight = 'mr-4',
}: {
  column: any;
  title: string;
  options: any;
  marginRight?: string;
}) {
  const selectedValues: string[] = column.getFilterValue() || [];
  const [open, setOpen] = useState(false);

  const toggleOptions = (option: string) => {
    const newValues = selectedValues.includes(option)
      ? selectedValues.filter((v) => v !== option)
      : [...selectedValues, option];

    column.setFilterValue(newValues.length ? newValues : undefined);
  };

  const clearFilters = () => {
    column.setFilterValue(undefined);
    setOpen(false);
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen} modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant={'outline'} className={marginRight}>
          {title}
          <Icon name="chevron-down" className="opacity-50" />
          {selectedValues.length > 0 && (
            <Chip className="bg-primary-700 -mr-6 mb-10 -ml-2 h-5 w-5 text-[12px] text-white">{`${selectedValues.length}`}</Chip>
          )}
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-54" side="bottom" align="start">
        {options.map(({ label, value }: { label: string; value: string }) => {
          return (
            <DropdownMenuCheckboxItem
              key={value}
              checked={selectedValues.includes(value)}
              onCheckedChange={() => toggleOptions(value)}
            >
              {label}
            </DropdownMenuCheckboxItem>
          );
        })}
        {selectedValues.length > 0 && open && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onSelect={(e) => {
                e.preventDefault();
                clearFilters();
              }}
              className="cursor-pointer pl-7"
            >
              Clear filters
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
